
<div class="tbl-frm">
<h1 *ngIf="formMode== 'EDIT'" class="mBottom2">{{'TABLES.EDIT_VALUE' | translate}}</h1>
<h1 *ngIf="formMode != 'EDIT'" class="mBottom2">{{'TABLES.ADD_VALUES' | translate}}</h1>

<form (ngSubmit)="submitForm()" [formGroup]="form">
    <div fxLayout="row" fxflex="100%">
        <div fxLayout="column" fxFlex="51%">
            <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: dataStructForm }"></ng-container>
            
            <ng-template #recursiveListTmpl let-list="list">
                <div *ngFor="let itemForm of list" >
                    <ng-container *ngIf="itemForm.children.length <= 0">
                        <dynamic-form-control *ngIf="itemForm.dataForm.controlType != 'TitleForm'" fxFlex [controlForm]="itemForm.dataForm" [form]="form" 
                            [browserLang]="browserLang" class="table-field" ></dynamic-form-control>
                    </ng-container>
                    <ng-container *ngIf="itemForm.children.length > 0">
                        <mat-accordion>
                            <mat-expansion-panel [expanded]="itemForm.showOpen">
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <h3 [attr.aria-expanded]="false">
                                        {{ browserLang == "en" ? itemForm.dataForm.label_en : itemForm.dataForm.label_es }}
                                    </h3>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: itemForm.children }"></ng-container>
                            </mat-expansion-panel>
                          </mat-accordion>                        
                    </ng-container>
                    <br/>
                </div>
            </ng-template>
           
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-raised-button (click)="cancelForm()">
                    {{'TABLES.CANCEL' | translate}}
                </button>
                <button mat-raised-button color="primary" class="right" cdkFocusInitial type="submit">
                    {{'TABLES.SAVE' | translate}}
                </button>
            </div>
        </div>
    </div>
</form>  
</div>